import { FC, ReactNode } from 'react';
import { trackFooterNavigationClick } from '../../helpers/trackingHelpers';
import { SeoLinkComponent } from 'dibs-seo/exports/SeoLink';

type Props = {
    trackingLabel: string;
    serverRenderedChildren: ReactNode;
    href: string;
    isLinkable: boolean;
    target?: '_blank';
    dataTn: string;
    linkContent: ReactNode;
};

const FooterSeoLinkWrapper: FC<Props> = ({
    trackingLabel,
    href,
    isLinkable,
    target,
    dataTn,
    linkContent,
}) => (
    <SeoLinkComponent
        onClick={() => {
            trackFooterNavigationClick({ label: trackingLabel });
        }}
        linkData={{
            path: href,
            isLinkable,
        }}
        target={target}
        dataTn={dataTn}
        buyerLinkType="contrastLinkLight"
    >
        {linkContent}
    </SeoLinkComponent>
);

export default FooterSeoLinkWrapper;
